/** @format */

import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconDeleteFilled,
	homefieldIconStarFilled0Percent
} from '@dsg-tech/homefield-angular-icons';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'plp-components-skeleton-compare-grid-product-card',
	imports: [HmfButtonComponent, HomefieldIconLibraryModule],
	templateUrl: './skeleton-compare-grid-product-card.component.html',
	styleUrl: './skeleton-compare-grid-product-card.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonCompareGridProductCardComponent {
	isCompact = input.required<boolean>();

	constructor(private readonly hmfIconService: HomefieldIconsLibraryService) {
		this.hmfIconService.registerIcons([
			homefieldIconStarFilled0Percent,
			homefieldIconDeleteFilled
		]);
	}

	trackbyFn(index: number): number {
		return index;
	}
}
